import React, { Fragment } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import MyDetailsTeam from '../MyDetailsTeam/MyDetailsTeam';
import MyDetailsCustomQuestions from '../MyDetailsCustomQuestions/MyDetailsCustomQuestions';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const MyDetailsExtra = props => {
  const { intl, userDetails, details, onChangeDetails, updateError, error, onResize, allowProfilePlusTeamPage } = props;

  return (
    <Fragment>
      <Accordion slotProps={{
        transition: { onEntered: onResize, onExited: onResize }
      }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="team-content" id="team-header">
          <QuestionAnswerIcon color='primary' />
          <Typography style={{marginLeft: 5}}>{intl.formatMessage({ id: 'my-questions' })}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <MyDetailsCustomQuestions
            userDetails={userDetails}
            details={details}
            onChangeDetails={onChangeDetails}
            updateError={updateError}
            error={error}
            onResize={onResize}
            allowProfilePlusTeamPage={allowProfilePlusTeamPage}
          />
        </AccordionDetails>
      </Accordion>
      <br />
      <Accordion slotProps={{
        transition: { onEntered: onResize, onExited: onResize }
      }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="team-content" id="team-header">
          <GroupAddIcon color='primary' />
          <Typography style={{marginLeft: 5}}>{intl.formatMessage({ id: 'Team' })}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <MyDetailsTeam
            userDetails={userDetails}
            details={details}
            onChangeDetails={onChangeDetails}
            updateError={updateError}
            error={error}
            onResize={onResize}
            allowProfilePlusTeamPage={allowProfilePlusTeamPage}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

export default MyDetailsExtra;
